import {useMutation, useQueryClient} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getHealthDistricts} from 'presentation/modules/booking/health/ui/pages/HealthBooking/steps/HealthDistrictSelection/services/getHealthDistricts';

export const useGetHealthDistrictsMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: getHealthDistricts,
		onSuccess: (data, variables) => {
			queryClient.setQueryData([QUERY_KEYS.DISTRICTS_HEALTH, variables], data);
		},
	});
};
